export interface IState {
  taskDataList: any;
  taskDetails: any;
}

type Action = any;

export const taskReducer = (
  state: IState = {
    taskDataList: [],
    taskDetails: null,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_WORKORDER_TASK":
      return {
        ...state,
        taskDataList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.taskDataList, ...action?.payload?.data],
      };
    case "GET_WORKORDER_TASK_DETAILS":
      return {
        ...state,
        taskDetails: action?.payload?.data,
      };
    case "CHANGE_WORK_TAST_STATUS":
      return {
        ...state,
        taskDetails:
          action?.payload?.id == state?.taskDetails?._id
            ? { ...state?.taskDetails, status: action?.payload?.status }
            : state?.taskDetails,
      };
    case "EDIT_TASK_MODULE_TASK":
      return {
        ...state,
        taskDetails: action?.payload,
      };

    case "CLEAR_WORK_ORDER_TASK_DATA":
      return {
        ...state,
        taskDataList: [],
      };
    // case "GET_WORK_ORDER_TASK_DATA":
    //   return {
    //     ...state,
    //     workorderTaskData: action?.payload?.data?.length > 0 ? action?.payload?.data : [],
    //   };
    // case "CHANGE_WORK_ORDER_STATUS":
    //   return {
    //     ...state,
    //     taskDetails:
    //       state?.taskDetails?._id == action?.payload?.id
    //         ? { ...state?.taskDetails, status: action?.payload?.status }
    //         : state?.taskDetails,
    //   };
    default:
      return state;
  }
};
